import React from 'react'

export class MapaVeiculo extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      andarSelecionado: 1
    }
  }

  // eslint-disable-next-line class-methods-use-this
  exibirCorredor (fileira) {
    return (fileira.exibeCorredor ? <div className="transport-meio-corredor" key={`corredor-${fileira.id}`}/> : '')
  }

  // eslint-disable-next-line class-methods-use-this
  exibirFileira (fileira) {
    if (fileira.assentos.length > 0) {
      return (
        <div className="transport-meio-fileira" key={`fileira-${fileira.numero}-${this.props.andar}`}>
          {this.exibirAssentos(fileira)}
          <label htmlFor="_" className="transport-meio-assento espaco-vago" key='meio6'>_</label>
        </div>
      )
    }
  }

  exibirAssentos (fileira) {
    return fileira.assentos.map(assento => <div key={`assento-${this.props.andar}-${fileira.numero}-${assento.ordem}`}>
      <label className={assento.tipoAssento === 'NORMAL' ? 'assento assento-disponivel  js-seat-selected-amplitude' : 'espaco-vago  js-seat-selected-amplitude'}>
        {assento.numero}
      </label>
    </div>)
  }

  exibirMapaVeiculo () {
    if (this.props.mapaVeiculo.fileirasPrimeiroAndar || this.props.mapaVeiculo.fileirasSegundoAndar) {
      const fileiras = this.state.andarSelecionado === 1 ? this.props.mapaVeiculo.fileirasPrimeiroAndar : this.props.mapaVeiculo.fileirasSegundoAndar;


      return (fileiras.map(fileira => <React.Fragment key={fileira.id}>
        <div>
          {this.exibirFileira(fileira)}
        </div>
        {this.exibirCorredor(fileira)}
      </React.Fragment>))
    }
  }

  // eslint-disable-next-line class-methods-use-this
  exibirAcoes () {
    if (this.props.mapaVeiculo.seDoisAndares) {
      return <div className="card" style={{
        width: '8rem'
      }}>
        <ul className="list-group list-group-flush">
          <li key='primeiro-andar' onClick={() => this.setState({ andarSelecionado: 1 })} className="list-group-item" style={{
            cursor: 'pointer',
            backgroundColor: this.state.andarSelecionado === 1 ? '#fa8d42' : ''
          }}><span className='ml-2'>1° andar</span></li>
          <li key='segundo-andar' onClick={() => this.setState({ andarSelecionado: 2 })} className="list-group-item" style={{
            cursor: 'pointer',
            backgroundColor: this.state.andarSelecionado === 2 ? '#fa8d42' : ''
          }}><span className='ml-2'>2° andar</span></li>
        </ul>
      </div>
    }
  }

  exibirBotoesSelecionarRemover (mapa) {
    if (this.props.selecionar) {
      return (
        <div className="d-flex flex-row-reverse mb-4 mr-4">
          <button className={this.props.selecionado ? 'btn btn-vermelho pull-right' : 'btn btn-laranja pull-right'} onClick={() => this.props.selecionar(mapa)}>
            {this.props.selecionado ? 'Remover' : 'Selecionar'}
          </button>
        </div>
      )
    }
  }

  render () {
    return (
      <React.Fragment>
        <div id='form-cardInicial' className='card'>
          {this.exibirAcoes()}
          <div className='row d-flex justify-content-center col-12'>
            <h3 className='mb-2'>{this.props.mapaVeiculo.modelo}</h3>
          </div>
          <div className="transport-result-wrapper transport-result-wrapper-connection " data-wrapper-direction="">
            <div className="js-count-transport">
              <div className="transport bus-design bus-design-side ">
                <div className="transport-frente"/>
                <div className="transport-meio transport-meio-thin">
                  {this.exibirMapaVeiculo()}
                </div>
                <div className="transport-traseira"/>
              </div>
            </div>
          </div>
         {this.exibirBotoesSelecionarRemover(this.props.mapaVeiculo)}
        </div>
      </React.Fragment>
    )
  }
}


export default (MapaVeiculo)
